<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          <router-link :to="{name:'user-center'}">个人中心</router-link>> 票券兑换
        </div>
        <left-userinfo></left-userinfo>
        <div class="right-user-wrap">
          <div class="score-wrap">
            可用余额
            <span>{{balance | jifen}}</span>
          </div>
          <div class="recharge-wrap">
            <div class="title">
              <h3 :class="{actived:curIndex===0}" @click="curIndex=0">充值卡充值</h3>
              <h3 :class="{actived:curIndex===1}" @click="curIndex=1">充值卡充值记录</h3>
              <h3 :class="{actived:curIndex===2}" @click="curIndex=2">使用说明</h3>
            </div>
            <el-row class="recharge-body" v-if="curIndex!=1">
              <el-col :span="12" v-if="curIndex==0">
                <ul class="info-body">
                  <li>
                    <span>卡号</span>
                    <el-input v-model="number" placeholder="请输入积分卡卡号"></el-input>
                  </li>
                  <li>
                    <span>密码</span>
                    <el-input v-model="password" placeholder="请输入积分卡密码"></el-input>
                  </li>
                  <el-button @click="recharge">确认充值</el-button>
                </ul>
              </el-col>
              <el-col :span="12" v-if="curIndex==2">
                <div class="scorecard_use_reminder">
                  <div class="scorecard_line"></div>
                  <div class="scorecard_use_step">
                    <div class="use_step_item">
                      <div class="use_step_circle">1</div>
                      <div class="use_step_text">登录http://www.xfsbz.cn;</div>
                    </div>
                    <div class="use_step_item">
                      <div class="use_step_circle">2</div>
                      <div class="use_step_text">使用手机号码注册成为幸福上班族会员;</div>
                    </div>
                    <div class="use_step_item">
                      <div class="use_step_circle">3</div>
                      <div class="use_step_text">点击网站右上角我要充值;</div>
                    </div>
                    <div class="use_step_item">
                      <div class="use_step_circle">4</div>
                      <div class="use_step_text">输入卡号和密码，将卡内余额充值到该账户中;</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="img-wrap">
                <img
                  src="http://small.shangbanzugroup.com/catalog/view/theme/rest/pc/images/card.png"
                  alt
                >
              </el-col>
            </el-row>
            <table class="scorecard-table-wrapper" v-else cellspacing="0">
              <thead class="scorecard-thead">
                <tr>
                  <th class="scorecard_history_day">日期</th>
                  <th class="scorecard_history_money">金额</th>
                  <th class="scorecard_history_method">操作</th>
                  <th class="scorecard_history_status">状态</th>
                </tr>
              </thead>
              <tbody class="scorecard-tbody">
                <tr>
                  <td>2019-02-13 08:35:31</td>
                  <td class="balance-asc">500.0000</td>
                  <td>积分卡充值:#xfsbz61896636</td>
                  <td>余额增加</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo
  },
  data() {
    return {
      balance: "",
      curIndex: 0,
      number:'',
      password:''
    };
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    getBalance() {
      this.$reqGet("api/distribch/account/balance").then(res => {
        this.balance = res.data.data.balance;
      });
    },
    recharge(){
      if(!this.number){
        this.$alert('请输入充值卡号')
        return
      }
      if(!this.password){
        this.$alert('请输入充值卡密码')
        return
      }
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-user-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  .score-wrap {
    padding: 20px;
    padding-left: 30px;
    border: 2px solid rgb(241, 160, 137);
    box-sizing: border-box;
    background-color: #fff;
    font-size: 16px;
    margin-bottom: 20px;
    span {
      color: #e2333f;
      margin-left: 20px;
    }
  }
  .recharge-wrap {
    background-color: #fff;
    padding: 20px 30px;
    min-height: 480px;
    box-sizing: border-box;
    .title {
      line-height: 42px;
      height: 42px;
      border-bottom: 2px solid #dadada;
      margin-bottom: 30px;
      h3 {
        display: inline-block;
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        box-sizing: border-box;
        padding: 0 20px;
        cursor: pointer;
        &.actived {
          border-bottom: 2px solid #FD6C17;
          font-size: 20px;
          color: #e2333f;
        }
      }
    }
    .recharge-body {
      padding: 30px 20px;
      .img-wrap {
        text-align: center;
        img {
          width: 355px;
        }
      }
    }
    .info-body {
      li {
        margin-bottom: 40px;
        .el-input {
          display: inline-block;
          width: 300px;
        }
        span {
          display: inline-block;
          width: 60px;
          text-align-last: justify;
          margin-right: 40px;
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      .el-button {
        width: 300px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        margin-left: 106px;
        font-size: 16px;
        background-color: #e2333f;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        border: none;
      }
    }
    .scorecard_use_reminder {
      position: relative;
      .scorecard_line {
        width: 2px;
        margin-left: 26px;
        background-color: #cc393e;
        height: 280px;
      }
      .scorecard_use_step {
        position: absolute;
        top: -35px;
        left: 0;
        overflow: hidden;
        .use_step_item {
          overflow: hidden;
          height: 55px;
          line-height: 55px;
          font-size: 0;
          margin-bottom: 35px;
          .use_step_circle {
            height: 55px;
            width: 55px;
            background-color: #cc393e;
            font-size: 24px;
            text-align: center;
            border-radius: 50%;
            color: #fff;
            float: left;
          }
          .use_step_text {
            font-size: 14px;
            color: #4c4c4c;
            margin-left: 20px;
            float: left;
          }
        }
      }
    }
    .scorecard-table-wrapper {
      border: none;
      margin-top: 5px;
      width: 100%;
      .scorecard-thead {
        border: 1px solid #eee;
        background-color: #f8f8f8;
        th {
          font-weight: normal;
          height: 48px;
          line-height: 48px;
          text-align: center;
        }
      }
      .scorecard-tbody {
        td {
          font-weight: normal;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border-bottom: 1px solid #eee;
        }
        .balance-asc{
          color: #e2333f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/recharge.vue